function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "check");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop-view",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Edit-group-details",
  transform: "translate(-487.000000, -1078.000000)",
  fill: "CurrentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M494.109356,1095.25 C494.265605,1095.25 494.390605,1095.20313 494.484355,1095.10938 L494.484355,1095.10938 L508.546821,1081.04691 C508.671821,1080.92191 508.734321,1080.78129 508.734321,1080.62504 C508.734321,1080.46879 508.671821,1080.34379 508.546821,1080.25004 L508.546821,1080.25004 L507.234324,1078.89067 C507.109324,1078.79692 506.9687,1078.75004 506.81245,1078.75004 C506.656201,1078.75004 506.531201,1078.79692 506.437451,1078.89067 L506.437451,1078.89067 L494.109356,1091.26564 L489.562492,1086.71877 C489.468742,1086.59377 489.343742,1086.53127 489.187492,1086.53127 C489.031243,1086.53127 488.890618,1086.59377 488.765622,1086.71877 L488.765622,1086.71877 L487.453122,1088.03127 C487.328122,1088.15627 487.265622,1088.29689 487.265622,1088.45314 C487.265622,1088.60939 487.328122,1088.73439 487.453122,1088.82814 L487.453122,1088.82814 L493.687482,1095.10938 C493.812482,1095.20313 493.953106,1095.25 494.109356,1095.25 Z",
  id: "check"
})));
const SvgCheck = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.96511d41.svg";
export { ForwardRef as ReactComponent };